import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import './styles.scss';

const Breadcrumb = (props) => {
    return (
        <section className={classNames({
            'breadcrumb': true,
            ...props.modifiers
        })}>
            {props.children}

            {!props.children && <Link to={props.url} onClick={props.onClick} className="breadcrumb__item" title={props.link_text}>{props.link_text}</Link>}
        </section>
    );
};

export default Breadcrumb;